import { RAISE_API_V1_URL } from "constants/endpoints";
import { get } from "services/api";

/**
 * @returns {Promise<Array<Object>>} A promise that resolves to an array of product sources with balance check information.
 * @returns {Object} product_source - The product source information.
 * @returns {number} product_source.id
 * @returns {string} product_source.name
 * @returns {string} product_source.slug
 * @returns {string} product_source.phone
 * @returns {string} product_source.balance_check_url
 */
export const getGiftCardBalanceList = async () => {
  const baseUrl = RAISE_API_V1_URL;
  const response = await get(`${baseUrl}/gift-card-balances`);

  return response.data;
};
